import { Injectable } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { ActiveUserConstants } from '../activeusers_api/constatnts/activeusers.constant';
import { HttpMethodsService } from '../_helpers/http-methods.service';
import { DevicesConstants } from './constants/devices.constants';

@Injectable({
  providedIn: 'root'
})
export class DevicesService {
  userId = sessionStorage.getItem('userId');
  loginUserRole = sessionStorage.getItem('userRole');
  retailerId = sessionStorage.getItem('retailerId');
  retailerName = sessionStorage.getItem('retailerName');
  storeId = sessionStorage.getItem('storeID');
  amaData = 'X-Amzn-Trace-Id';
  isAllSelectedReports = false;
  deviceSrtUrl = DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_SRT + DevicesConstants.SLASH_DEVICE;
  devicesCommonUrl = DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_USERS;
  retailerUrl = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}`;
  regionalUrl = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}`;
  storeUrl = `${this.retailerUrl}${DevicesConstants.SLASH_STORES}${DevicesConstants.SLASH}${this.storeId}`;
  getDevicesUrl = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE || this.loginUserRole === GlobalConstants.REGIONALHQ ||  this.loginUserRole ===  GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) ?
    `${this.retailerUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` :
    `${this.storeUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;
  patchDeviceUrl = `${this.retailerUrl}${DevicesConstants.SLASH_STORES}`;

  deviceStatusUrl = DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_RETAILERS
    + DevicesConstants.SLASH + this.retailerId + DevicesConstants.SLASH_DEVICES + DevicesConstants.CHART;
  deviceDownloadReportUrl = `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}`;
  deviceActiveReportIntelAdmin = `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SLASH_DOWNLOAD}`;
  deviceStoreStatusUrl = DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_RETAILERS
    + DevicesConstants.SLASH + this.retailerId + DevicesConstants.SLASH_STORES + DevicesConstants.SLASH + this.storeId +
    DevicesConstants.SLASH_DEVICES + DevicesConstants.CHART;
  constructor(private httpMethodsService: HttpMethodsService) { }

  getAllDevicesByUserID(sortby: string, sorttype: string, pageNumber: number, filterString?: string, retailerUserId?: string) {
    let url = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE || this.loginUserRole ===  GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) ?
      `${this.retailerUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype
      + DevicesConstants.PAGE_NUMBER + DevicesConstants.EQUALS + pageNumber :
      this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE ?
        `${this.regionalUrl}${retailerUserId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype
        + DevicesConstants.PAGE_NUMBER + DevicesConstants.EQUALS + pageNumber : this.loginUserRole === GlobalConstants.SRT_ADMIN ? `${this.deviceSrtUrl}` + DevicesConstants.RETAILERID + retailerUserId + DevicesConstants.SORT_BY + sortby + DevicesConstants.SORT_TYPE + sorttype
          + DevicesConstants.PAGE_NUMBER + DevicesConstants.EQUALS + pageNumber :
          `${this.storeUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` + DevicesConstants.SORTBY + sortby + DevicesConstants.SORT_TYPE + sorttype
          + DevicesConstants.PAGE_NUMBER + DevicesConstants.EQUALS + pageNumber;

    if (filterString) {
      url = `${url}${filterString}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  getAllDevicesStatus() {
    const url = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE) ?
      this.deviceStatusUrl : (this.loginUserRole === GlobalConstants.REGIONALHQ ||this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE ) ? DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_DEVICE + DevicesConstants.SLASH_RETAILERS
        + DevicesConstants.SLASH + sessionStorage.getItem('retailerId') + DevicesConstants.SLASH_DEVICES + DevicesConstants.CHART : this.deviceStoreStatusUrl;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  sort(tempval: string, temporder: string) {
    const url = `${this.getDevicesUrl}${DevicesConstants.SORTBY}${tempval}${DevicesConstants.SORT_TYPE}${temporder}`;

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  updateViaCSV(configurationsJson: object) {
    const url = `${this.storeUrl}${DevicesConstants.SLASH_UPLOAD}`;

    return this.httpMethodsService.patchCSV(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  updateViaCSVRetailHQUser(configurationsJson: object, isDashboardPriceSupress: boolean, isCustomHeroTile: boolean) {
    let url = '';
    url = `${this.retailerUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_UPLOAD}${DevicesConstants.PRICE_SUPPRESS}${isDashboardPriceSupress}${GlobalConstants.IS_CUSTOM_TILE_ENABLED}${isCustomHeroTile}`;
    return this.httpMethodsService.patchCSV(url, configurationsJson)
      .pipe(map((res: any) =>
        res));
  }

  getUsersbySearch(searchTag: string, searchData: any) {
    return this.httpMethodsService.get(
      this.getDevicesUrl
      + DevicesConstants.SEARCH_QUERY
      + searchTag
      + DevicesConstants.EQUALS
      + searchData)
      .pipe(map((res: any) =>
        res));

  }

  getDevicesByFilter(filterString: string) {
    this.retailerUrl = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${sessionStorage.getItem('userId')}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${sessionStorage.getItem('retailerId')}`;
    this.getDevicesUrl = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE || this.loginUserRole === GlobalConstants.REGIONALHQ || this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) ?
      `${this.retailerUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` :
      `${this.storeUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;
    const filterURL = `${this.getDevicesUrl}${filterString}`;
    return this.httpMethodsService.get(filterURL)
      .pipe(map((res: any) =>
        (res))
      );
  }

  updateAllDevices(payload, retailerID: string) {
    let sendUrl = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;
    if (this.storeId !== 'undefined') {
      sendUrl = `${this.storeUrl}/devices`;
    }
    return this.httpMethodsService.patch(sendUrl, payload)
      .pipe(map((res: any) =>
        res));
  }
  genearateDownloadURL(retailerid, isPricesupress?: boolean, isCustomTile?: boolean, isTimezoneCST?: boolean) {
    let downloadDeviceUrl = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE || this.loginUserRole === GlobalConstants.REGIONALHQ || this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) ?
      `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerid}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH}${DevicesConstants.DOWNLOAD}${GlobalConstants.IS_DOWNLOAD_PRICE_SUPRESS}${isPricesupress}${GlobalConstants.IS_CUSTOM_TILE_ENABLED}${isCustomTile}` :
      this.loginUserRole === GlobalConstants.SRT_ADMIN ? `${this.deviceSrtUrl}${DevicesConstants.SLASH_DOWNLOAD}${DevicesConstants.RETAILERID}${retailerid}` :
        `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerid}${DevicesConstants.SLASH_STORES}${DevicesConstants.SLASH}${this.storeId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH}${DevicesConstants.DOWNLOAD}${GlobalConstants.IS_DOWNLOAD_PRICE_SUPRESS}${isPricesupress}
      ${GlobalConstants.IS_CUSTOM_TILE_ENABLED}${isCustomTile}`;
    if (isTimezoneCST) downloadDeviceUrl += `${GlobalConstants.IS_TIMEZONE_CST}`;
    return downloadDeviceUrl;
  }
    
    postAllUsersForCsv(data, retailerid, isPricesupress: boolean, isCustomTile: boolean,pfID, isTimezoneCST: boolean) {
      let URL = this.genearateDownloadURL(retailerid, isPricesupress, isCustomTile, isTimezoneCST);
      if(pfID != ''){
        URL += '&package='+pfID;
      }
    //Preparing custom URL inside function to avoid session storage access issues.UAT-568
    return this.httpMethodsService.postcsv(URL, data)
      .pipe(map((res: any) =>
        res));
  }

  deleteDevices(removeDevices, retailerid?) {
    const deleteURL = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE || this.loginUserRole === GlobalConstants.REGIONALHQ) ?
      `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerid}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` :
      `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerid}${DevicesConstants.SLASH_STORES}${DevicesConstants.SLASH}${this.storeId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;

    return this.httpMethodsService.deleteUser(deleteURL, removeDevices)
      .pipe(map((res: any) => res));
  }

  deleteSrtDevices(removeDevices, retailerid?) {
    const deleteSrtURL = `${this.deviceSrtUrl}${DevicesConstants.SLASH_USERS}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerid}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;
    return this.httpMethodsService.deleteUser(deleteSrtURL, removeDevices)
      .pipe(map((res: any) => res));
  }

  postdownloadcsvDevicebyFilter(filterString: string, params, retailerid, isPricesupress: boolean, isCustomTileEnabled: boolean, isTimezoneCST: boolean) {
    return this.httpMethodsService.postfiltercsv(this.genearateDownloadURL(retailerid, isPricesupress, isCustomTileEnabled, isTimezoneCST) + filterString, JSON.stringify(params))
      .pipe(map((res: any) => res));
  }

  deviceSettingPatchReq(payload, retailerID) {
    let sendUrl = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;
    if (this.storeId !== 'undefined') {
      sendUrl = `${this.storeUrl}/devices`;
    }

    return this.httpMethodsService.patch(sendUrl, payload)
      .pipe(map((res: any) =>
        res));
  }
  fullReportDownload(payload, retailerUserID: string, getstoreId?, flag?:boolean) {
    let sendURL;
    if (this.loginUserRole === GlobalConstants.INTEL_ADMIN) {
      flag = true;
      sendURL =  `${this.deviceActiveReportIntelAdmin}${DevicesConstants.SEARCH_QUERY}${DevicesConstants.UNISONDEMO}${DevicesConstants.EQUALS}${flag}`
    } else if (this.loginUserRole === GlobalConstants.RETAIL_HQ_USER || this.loginUserRole === GlobalConstants.REGIONALHQ || this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) {
      sendURL = (flag == true) ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerUserID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SLASH_DOWNLOAD}${DevicesConstants.SEARCH_QUERY}${DevicesConstants.UNISONDEMO}${DevicesConstants.EQUALS}${flag}` :
        `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerUserID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SLASH_DOWNLOAD}`
    } else {
      sendURL = `${this.deviceDownloadReportUrl}${DevicesConstants.SLASH_DOWNLOAD}${DevicesConstants.STROEID_PARAMS}${getstoreId}`
    }

    return this.httpMethodsService.postcsv(sendURL, payload)
      .pipe(map((res: any) =>
        res));
  }
  reportDownloadById(payload, id, retailerID: string, flag?:boolean) {
    let sendURL;
    if (this.loginUserRole === GlobalConstants.INTEL_ADMIN) {
      flag = true;
      sendURL =  `${this.deviceActiveReportIntelAdmin}${DevicesConstants.PARAM_RETAILERID}${id}${DevicesConstants.PARAM_UNISONDEMO}${flag}`
    } else if (this.loginUserRole === GlobalConstants.RETAIL_HQ_USER || this.loginUserRole === GlobalConstants.REGIONALHQ) {
      sendURL = (flag == true) ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SLASH_DOWNLOAD}${DevicesConstants.STROEID_PARAMS}${id}${DevicesConstants.PARAM_UNISONDEMO}${flag}` :
        `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SLASH_DOWNLOAD}${DevicesConstants.STROEID_PARAMS}${id}`
    } else {
      sendURL = `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SLASH_DOWNLOAD}${DevicesConstants.STROEID_PARAMS}${id}`
    }

    return this.httpMethodsService.postcsv(sendURL, payload)
      .pipe(map((res: any) =>
        res));
  }

  getActiveDeviceReport(sortby: string, sortType: string, pageNumber: number, filterString?: string, retailerID?: string) {
    let url = this.loginUserRole === GlobalConstants.INTEL_ADMIN ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SORTBY}${sortby}${DevicesConstants.SORT_TYPE}${sortType}${DevicesConstants.PAGE_NUMBER}${DevicesConstants.EQUALS}${pageNumber}` :
      (this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE || this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retailerID}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SORTBY}${sortby}${DevicesConstants.SORT_TYPE}${sortType}${DevicesConstants.PAGE_NUMBER}${DevicesConstants.EQUALS}${pageNumber}` :
        `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SORTBY}${sortby}${DevicesConstants.SORT_TYPE}${sortType}${DevicesConstants.PAGE_NUMBER}${DevicesConstants.EQUALS}${pageNumber}`;

    if (filterString) {
      url = `${url}${filterString}`;
    }
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  getAllSelectedActiveDeviceReport() {
    this.isAllSelectedReports = true;
    let url = ``;
    if (this.loginUserRole === ActiveUserConstants.RETAIL_USER_ROLE || this.loginUserRole === ActiveUserConstants.REGIONAL_USER_ROLE || this.loginUserRole === ActiveUserConstants.STORE_ROLE || this.loginUserRole === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) {
      url = `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${sessionStorage.getItem('retailerId')}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}`
    } else if (this.loginUserRole === GlobalConstants.INTEL_ADMIN) {
      url = `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}`;
    }
    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }


  selectAllDevices(filterString?: string, retailerUserId?: string) {
    this.retailerUrl = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${sessionStorage.getItem('userId')}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${sessionStorage.getItem('retailerId')}`;
    this.getDevicesUrl = (this.loginUserRole === DevicesConstants.RETAIL_HQ_ROLE || this.loginUserRole === GlobalConstants.REGIONALHQ) ?
      `${this.retailerUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}` : this.loginUserRole === GlobalConstants.SRT_ADMIN ?
        `${this.deviceSrtUrl}${DevicesConstants.RETAILERID}${retailerUserId}` :
        `${this.storeUrl}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}`;

    let url = this.getDevicesUrl;
    if (filterString && this.loginUserRole === GlobalConstants.SRT_ADMIN) {
      url = `${url}${filterString}`;
    } else if (filterString) {
      url = `${url}?${filterString}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }
  displayActiveDeviceSort(type, sortType: string, search?: string) {
    let url = this.loginUserRole === GlobalConstants.INTEL_ADMIN ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SORTBY}${type}${DevicesConstants.SORT_TYPE}${sortType}` :
      `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SORTBY}${type}${DevicesConstants.SORT_TYPE}${sortType}`;
    if (search) {
      url = this.loginUserRole === GlobalConstants.INTEL_ADMIN ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SEARCH_BY}${search}${DevicesConstants.SORT_BY}${type}${DevicesConstants.SORT_TYPE}${sortType}` :
        `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SEARCH_BY}${search}${DevicesConstants.SORT_BY}${type}${DevicesConstants.SORT_TYPE}${sortType}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  searchAvtiveDeviceReport(name: string, sortType?: string, sortBy?: string) {
    let url = this.loginUserRole === GlobalConstants.INTEL_ADMIN ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SEARCH_BY}${name}` :
      `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SEARCH_BY}${name}`;
    if (sortType) {
      url = this.loginUserRole === GlobalConstants.INTEL_ADMIN ? `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SEARCH_BY}${name}${DevicesConstants.SORT_BY}${sortType}${DevicesConstants.SORT_TYPE}${sortBy}` :
        `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${this.retailerId}${DevicesConstants.SLASH}${DevicesConstants.DEVICES}${DevicesConstants.SLASH_REPORT}${DevicesConstants.SEARCH_BY}${name}${DevicesConstants.SORT_BY}${sortType}${DevicesConstants.SORT_TYPE}${sortBy}`;
    }

    return this.httpMethodsService.get(url)
      .pipe(map((res: any) =>
        res));
  }

  //IIT3-314
  stopUpdatesOnNewDevices(payload) {
    let sendUrl = `${DevicesConstants.SLASH}${DevicesConstants.ASSET_LIB}${DevicesConstants.SLASH_USERS}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH}${DevicesConstants.ASSET_LIB}${DevicesConstants.SLASH}${DevicesConstants.ASSET_LIB}-${this.userId}${DevicesConstants.PUSH_NEW_DEVICE}`;
    return this.httpMethodsService.patch(sendUrl, payload)
      .pipe(map((res: any) =>
        res));
  }

  // For IGC-4
  updateSingleAndMultipleSrtDevices(payload) {
    let sendUrl = `${DevicesConstants.SLASH_DEVICE}${DevicesConstants.SLASH_SRT}${DevicesConstants.SLASH_DEVICE}`;
    return this.httpMethodsService.patch(sendUrl, payload)
      .pipe(map((res: any) =>
        res));
  }

  //For IGC-12
  DownloadAllSrtDevices(payload, retailerid) {
    return this.httpMethodsService.postcsv(this.genearateDownloadURL(retailerid), payload)
      .pipe(map((res: any) =>
        res));
  }
  
  // For IGC-12
  postdownloadcsvSrtDevicebyFilter(filterString: string, params, retailerid) {
    return this.httpMethodsService.postfiltercsv(this.genearateDownloadURL(retailerid) + filterString, JSON.stringify(params))
      .pipe(map((res: any) => res));
  }
  pushProfiles(retID,payload,storeID){
    let Url = `${this.devicesCommonUrl}${DevicesConstants.SLASH}${this.userId}${DevicesConstants.SLASH_RETAILERS}${DevicesConstants.SLASH}${retID}${DevicesConstants.SLASH}`;
    if(storeID !== "") Url += `stores${DevicesConstants.SLASH}${storeID}${DevicesConstants.SLASH}`
    Url += `devices?profilePush=true`;
    return this.httpMethodsService.patch(Url, payload)
      .pipe(map((res: any) =>
        res));
  }
}

